export default __webpack_public_path__ + "static/media/Slider_500_Web.98e1711c.webp";